import { useEffect, useState } from 'react';

const getIsWindowScrolled = (): boolean => (typeof window !== 'undefined' ? window.scrollY !== 0 : false);

const useIsScrolled = (): boolean => {
    const [isScroll, setScroll] = useState(false);

    useEffect(() => {
        if (!__isBrowser__ || typeof window === 'undefined') {
            return;
        }

        const handleScroll = (): void => {
            setScroll(getIsWindowScrolled());
        };

        window.addEventListener('scroll', handleScroll);
        handleScroll();

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return isScroll;
};

export default useIsScrolled;
